import type { ReactNode } from 'react';

import { PageHeader } from '../../components/PageHeader';

export type ReportStatusTone = 'ok' | 'warn' | 'danger' | 'neutral';

export function ReportHeader({
  title,
  subtitle,
  actions,
  status,
}: {
  title: ReactNode;
  subtitle: ReactNode;
  actions?: ReactNode;
  status?: { label: string; tone: ReportStatusTone };
}) {
  return (
    <PageHeader
      title={title}
      subtitle={subtitle}
      actions={actions}
      status={status}
    />
  );
}
